import { useReportBuilderStore } from '../../stores/reportBuilderStore';
import { Plus, Trash, ArrowsDownUp } from '@phosphor-icons/react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@t-one-internal/design-system';

export default function SortBuilder() {
  const { selectedModel, selectedModelKeys, sorts, getSortableColumns, addSort, removeSort, updateSort } = useReportBuilderStore();
  if (!selectedModel) return null;

  const sortableColumns = getSortableColumns();
  const hasJoins = selectedModelKeys.length > 1;

  const renderColumnItems = () => {
    if (!hasJoins) {
      return sortableColumns.map(c => <SelectItem key={c.key} value={c.key}>{c.label}</SelectItem>);
    }

    const groups: Record<string, typeof sortableColumns> = {};
    for (const col of sortableColumns) {
      const modelName = col.sourceModelName || 'Measures';
      if (!groups[modelName]) groups[modelName] = [];
      groups[modelName].push(col);
    }

    return Object.entries(groups).map(([modelName, cols]) => (
      <div key={modelName}>
        <div className="px-2 py-1 text-xs font-semibold text-muted-foreground">{modelName}</div>
        {cols.map(c => <SelectItem key={c.key} value={c.key}>{c.label}</SelectItem>)}
      </div>
    ));
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700">Sort</span>
        <button
          onClick={() => { const c = sortableColumns[0]; if (c) addSort({ column: c.key, direction: 'asc' }); }}
          disabled={sortableColumns.length === 0}
          className="flex items-center gap-1 rounded px-2 py-1 text-xs text-blue-600 hover:bg-blue-50 disabled:opacity-40 disabled:cursor-not-allowed">
          <Plus className="h-3 w-3" /> Add Sort
        </button>
      </div>

      {sorts.map((s) => (
        <div key={s.id} className="flex items-center gap-1">
          <div className="flex-1">
            <Select value={s.column} onValueChange={(val) => updateSort(s.id, { column: val })}>
              <SelectTrigger className="h-7 text-xs">
                <SelectValue placeholder="Select column" />
              </SelectTrigger>
              <SelectContent>
                {renderColumnItems()}
              </SelectContent>
            </Select>
          </div>
          <button onClick={() => updateSort(s.id, { direction: s.direction === 'asc' ? 'desc' : 'asc' })}
            className="flex items-center gap-1 rounded border border-gray-300 px-2 py-1 text-xs hover:bg-gray-50">
            <ArrowsDownUp className="h-3 w-3" /> {s.direction.toUpperCase()}
          </button>
          <button onClick={() => removeSort(s.id)} className="rounded p-1 text-gray-400 hover:bg-red-50 hover:text-red-500">
            <Trash className="h-3.5 w-3.5" />
          </button>
        </div>
      ))}
      {sorts.length === 0 && <p className="text-xs text-gray-400 italic">No sort applied</p>}
    </div>
  );
}
